import { Fragment, useMemo } from 'react'

import { type Control, useController } from 'react-hook-form'

import { classNames } from '@/utils/helpers'

import { Switch } from '../switch.tsx'
import { Tooltip } from '../tooltip.tsx'

interface FormSwitchProps {
  label?: string | React.ReactNode
  name: string
  control: Control<any, any>
  className?: string
  labelClassName?: string
  labelTextClassName?: string
  disabled?: boolean
  labelBeforeSwitch?: boolean
  tooltip?: string
}

export const FormSwitch = ({
  label,
  name,
  control,
  className,
  labelClassName,
  disabled,
  labelBeforeSwitch,
  labelTextClassName,
  tooltip,
}: FormSwitchProps) => {
  const { field } = useController({ name, control })
  const Wrapper = tooltip ? Tooltip : Fragment
  const switchContent = useMemo(
    () => (
      <Wrapper content={tooltip}>
        <Switch
          checked={field.value}
          onCheckedChange={(value) => field.onChange({ target: { value } })}
          disabled={disabled}
          className={className}
          {...field}
          id={field.name}
        />
      </Wrapper>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [className, disabled, field],
  )

  return (
    <label
      htmlFor={field.name}
      className={classNames('flex items-center gap-2', labelClassName)}
    >
      {labelBeforeSwitch ? (
        <>
          {label && (
            <span
              className={classNames(
                'select-none text-sm font-medium text-text-default',
                labelTextClassName,
              )}
            >
              {label}
            </span>
          )}
          {switchContent}
        </>
      ) : (
        <>
          {switchContent}
          {label && <span className="select-none text-sm">{label}</span>}
        </>
      )}
    </label>
  )
}
